import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class TimezoneInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const clonedRequest = req.clone({
      setHeaders: { tz },
    });
    return next.handle(clonedRequest);
  }
}
